import React from 'react';

const LoadingState = ({ message = "Loading data..." }) => (
  <div className="bg-white rounded-lg shadow-sm p-6 mb-6 flex justify-center items-center h-96">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-4"></div>
      <p className="text-gray-600">{message}</p>
    </div>
  </div>
);

export default LoadingState;